import { useEffect, useState } from "react"
import { useProductTourV2 } from "../stores/use-product-tour"
import { useAuth } from "@/modules/auth/store"
import { PRODUCT_TOUR_V2_STEPS } from "../types/steps"

const videoUrls = {
  [PRODUCT_TOUR_V2_STEPS.STUDY]:
    "https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/study.mp4",
  [PRODUCT_TOUR_V2_STEPS.MY_SITUATION]:
    "https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/my-situation.mp4",
}

export default function useControlProductTour() {
  const [showVideo, setShowVideo] = useState(false)
  const { currentStep, isActive, setIsActive } = useProductTourV2()
  const [videoUrl, setVideoUrl] = useState<string>(videoUrls[currentStep])
  const { user } = useAuth()

  useEffect(() => {
    if (user.productTour === null) {
      setIsActive(true)
      setShowVideo(true)
    }
  }, [user.productTour])

  useEffect(() => {
    if (!isActive) return
    setVideoUrl(videoUrls[currentStep])
  }, [currentStep, isActive])

  useEffect(() => {
    if (user.productTour !== null) {
      setIsActive(false)
      setShowVideo(false)
    }
  }, [user.productTour])

  return { showVideo, videoUrl }
}
